import styled from 'styled-components';
import {
  BaseListContainer,
  commonListContentStyles
} from '../shared/SharedListStyles';

export const Container = styled(BaseListContainer)`
  padding: 0px 5px;
  border-left: 3px solid var(--grey-300);
  border-right: 3px solid var(--grey-300);
  flex: 1;

  .route-list-content {
    ${commonListContentStyles}
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
  }

  .field-content {
    input[type='number'] {
      height: 30px !important;

      & + div {
        height: 28px !important;
        button {
          height: 14px !important;
        }
      }
    }
    svg {
      font-size: 16px;
    }
  }

  .list-container {
    display: flex;
    background-color: var(--grey-100);
    height: 100%;
    width: 100%;
  }

  .route-item {
    border: 1px solid var(--grey-200);
    padding: 12px;
    position: relative;
    width: ${(props) => props.itemWidth};
  }

  .route-item:nth-child(odd) {
    background: #fff;
  }

  .route-item:nth-child(even) {
    background: #fff;
  }

  .routeMonitorProgressBarContainer {
    z-index: 0 !important;
  }

  [data-testid='date-icon-date-range-start'],
  [data-testid='date-icon-date-range-end'] {
    padding: 0 !important;
  }
`;
